<template>
    <div class="modal-mask" v-show="show" transition="modal">
        <div class="modal-wrapper">
        <div class="modal-container">
            <div class="modal-header">
            <slot name="header">default header</slot>
            </div>

            <div class="modal-body">
            <slot name="body">default body</slot>
            </div>

            <div class="modal-footer">
            <slot name="footer">
                <button class="modal-button" @click="close">Close</button>
            </slot>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    data: function () {
        return { show: false }
    },
    methods: {
        open: function () {
            this.show = true
        },
        close: function () {
            this.show = false
        }
    }
}
</script>

<style>
    .modal-mask {
        position: fixed;
        z-index: 99;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        display: block;
        margin-top: 60px;
        margin-bottom: 60px;
    }
    .modal-container {
        min-width: 600px;
        max-width: 900px;
        margin: 0px auto;
        padding: 10px 15px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
    .modal-header {
        padding-top: 5px;
    }
    .modal-body {
        margin: 10px;
        padding: 0px;
        max-height: 71vh;
        overflow-y: auto;
        overflow-x: hidden;

    }
    .modal-footer {
        padding-bottom: 5px;
    }
    .modal-button {
        float: right
    }
    .modal-enter,
    .modal-leave {
        opacity: 0
    }
    .modal-enter .modal-container,
    .modal-leave .modal-container {
        transform: scale(1.1)
    }
</style>



// WEBPACK FOOTER //
// Modal.vue?90171b92